/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import * as sanitizeHtml from 'sanitize-html';

// ====

const OEmbed = (props) => {
  const { src, seo } = props;

  return (
    <div className="brand-video">
      <div
        className="brand-video-embed"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(src, {
            allowedTags: ['p', 'em', 'strong', 'iframe'],
            allowedClasses: {
              p: ['fancy', 'simple'],
            },
            allowedAttributes: {
              iframe: ['src', 'width', 'height', 'frameborder', 'allow'],
            },
            allowedIframeHostnames: [
              'youtube.com',
              'www.youtube.com',
              'player.vimeo.com',
              'strawpoll.me',
              'www.strawpoll.me',
              'player.twitch.tv',
              'www.mixer.com',
              'mixer.com',
              'libsyn.com',
              'html5-player.libsyn.com',
            ],
          }),
        }}
      />
    </div>
  );
};

export default OEmbed;

// ====

OEmbed.propTypes = {
  src: PropTypes.string.isRequired,
  seo: PropTypes.string,
};
OEmbed.defaultProps = {
  seo: null,
};
